// extracted by mini-css-extract-plugin
export var bottomrow = "IntroRehoming-module--bottomrow--63f64";
export var columnscurvedborder = "IntroRehoming-module--columnscurvedborder--6d924";
export var columnscurvedborderwrapper = "IntroRehoming-module--columnscurvedborderwrapper--98918";
export var dogimage = "IntroRehoming-module--dogimage--50521";
export var introcolumninner = "IntroRehoming-module--introcolumninner--bdec9";
export var introcolumnouter = "IntroRehoming-module--introcolumnouter--a7f6a";
export var leftcolumn = "IntroRehoming-module--leftcolumn--e36eb";
export var rightcolumn = "IntroRehoming-module--rightcolumn--d5cc6";
export var rowscurvedborder = "IntroRehoming-module--rowscurvedborder--70181";
export var rowscurvedborderwrapper = "IntroRehoming-module--rowscurvedborderwrapper--bdede";
export var text = "IntroRehoming-module--text--ad9b7";
export var toprow = "IntroRehoming-module--toprow--6bceb";
export var twocolumncontent = "IntroRehoming-module--twocolumncontent--f95bb";
export var tworowcontent = "IntroRehoming-module--tworowcontent--930af";